import type CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';

// Triggers that belong to the "Photos" bucket for the contextual auth copy experiment (GROW-18026).
// When the sign up modal is shown on mWeb via one of these triggers, the headline is replaced with
// action-specific photos copy. Keep in sync with the Photos bucket defined on the experiment ticket.
const photoTriggers: CarouselDisplayTrigger[] = [
  'View Trail Photos',
  'See More Photos',
  'Gallery Tour',
  'Add Photo to Trail',
  'Custom Route Card Photo Tour'
];

export default photoTriggers;
